import Choices from "choices.js";

let element = document.querySelector('#educator_selector');

window.choicesTranslate = function (keyword) {
    let lang = document.querySelector("html").getAttribute("lang");
    if (lang === null) lang = "tr";

    const translations = {
        tr: {
            "Eğitmen seçin": "Eğitmen seçin",
            "Yükleniyor...": "Yükleniyor...",
            "Arama sonucu bulunamadı": "Arama sonucu bulunamadı",
            "Seçecek değer bulunamadı": "Seçecek değer bulunamadı",
            "Seçmek için tıklayın": "Seçmek için tıklayın",
            "Sorumlu seçin": "Sorumlu seçin",
        },
        en: {
            "Eğitmen seçin": "Choose Educator",
            "Yükleniyor...": "Loading...",
            "Arama sonucu bulunamadı": "No results found",
            "Seçecek değer bulunamadı": "No choices to choose from",
            "Seçmek için tıklayın": "Click to select",
            "Sorumlu seçin": "Choose Responsible",
        },
    };

    if (translations[lang][keyword]) {
        return translations[lang][keyword];
    }

    return keyword;
};

if (element) {


    // get current language from html tag lang attribute
    const lang = document.querySelector('html').getAttribute('lang');
    console.log('im here broh.....', lang);

    var multipleFetch = new Choices('#educator_selector', {
        allowHTML: false,
        placeholder: true,
        placeholderValue: choicesTranslate('Eğitmen seçin'),
        removeItemButton: true,
        loadingText: choicesTranslate('Yükleniyor...'),
        noResultsText: choicesTranslate('Arama sonucu bulunamadı'),
        noChoicesText: choicesTranslate('Seçecek değer bulunamadı'),
        itemSelectText: choicesTranslate('Seçmek için tıklayın'),
      }).setChoices(function() {
        return fetch(
          '/admin/api/educators',
        )
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            return data.map(function(educator) {
              return { value: educator.id, label: educator.title };
            });
          });
      });

}


let element2 = document.querySelector('#user_selector');

if (element2) {
    const users = element2.getAttribute('data-users');
    var multipleFetch = new Choices('#user_selector', {
        allowHTML: false,
        placeholder: true,
        placeholderValue: choicesTranslate('Sorumlu seçin'),
        removeItemButton: true,
        loadingText: choicesTranslate('Yükleniyor...'),
        noResultsText: choicesTranslate('Arama sonucu bulunamadı'),
        noChoicesText: choicesTranslate('Seçecek değer bulunamadı'),
        itemSelectText: choicesTranslate('Seçmek için tıklayın'),
      }).setChoices(function() {
        return users.map(user => {
            return {
                value: user.id,
                label: user.name,
            }
        });
      });

}


